<ng-template #table>
  <table [attr.aria-label]="'Pfandrechtbelastungen' | translate" class="cap-table-detail">
    <thead>
      <tr>
        <th>{{"Grundstück" | translate}}</th>
        <th>{{"Belastung" | translate}}</th>
        <th>{{"Rechtsgrund" | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (belastung of recht.belastungen | orderByGrundstuecknummer; track belastung) {
        @for (belastungVersion of belastung.versions; track belastungVersion; let last = $last) {
          <tr>
            <td>
              <cap-kompakt-grundstueck [capHistinfo]="belastungVersion.histInfo" [item]="belastung.grundstueck"></cap-kompakt-grundstueck>
            </td>
            <td>
              <cap-kompakt-pfandrecht-belastung
                [belastung]="belastungVersion"
                [belastungMaster]="belastung"
                [capHistinfo]="belastungVersion.histInfo"
                format="GRUNDPFANDRECHTBELASTUNG_TYP01">
              </cap-kompakt-pfandrecht-belastung>
              <cap-kompakt-timepoint [item]="belastungVersion.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @if (last) {
                @for (rechtsgrund of belastung.rechtsgruende; track rechtsgrund) {
                  <p>
                    <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                  </p>
                }
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</ng-template>

@if (!recht || recht.belastungen.length == 0) {
  <ng-template [ngTemplateOutlet]="keine"></ng-template>
} @else {
  <table [attr.aria-label]="'Pfandrechtbelastungen' | translate" class="cap-table-detail">
    <thead>
      <tr>
        <th>{{"Grundstück" | translate}}</th>
        <th>{{"Belastung" | translate}}</th>
        <th>{{"Rechtsgrund" | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (belastung of recht.belastungen | orderByGrundstuecknummer; track belastung) {
        @for (belastungVersion of belastung.versions; track belastungVersion; let last = $last) {
          <tr>
            <td>
              <cap-kompakt-grundstueck [capHistinfo]="belastungVersion.histInfo" [item]="belastung.grundstueck"></cap-kompakt-grundstueck>
            </td>
            <td>
              <cap-kompakt-pfandrecht-belastung
                [belastung]="belastungVersion"
                [belastungMaster]="belastung"
                [capHistinfo]="belastungVersion.histInfo"
                format="GRUNDPFANDRECHTBELASTUNG_TYP01">
              </cap-kompakt-pfandrecht-belastung>
              <cap-kompakt-timepoint [item]="belastungVersion.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @if (last) {
                @for (rechtsgrund of belastung.rechtsgruende; track rechtsgrund) {
                  <p>
                    <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                  </p>
                }
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
}
<ng-template #keine>
  <div class="mb-2">
    <span>{{"Keine" | translate}}</span>
  </div>
</ng-template>
